export async function getUsers() {
  try {
    const response = await fetch(
      "https://m2xnsqjvec.execute-api.ap-southeast-1.amazonaws.com/prod/getUsers",
      { method: "GET", headers: { "Content-Type": "application/json" } }
    );

    if (response.ok) {
      const payload = await response.json();
      const list = Array.isArray(payload) ? payload : (payload?.users || []);
      return list.sort((a, b) => a.username.localeCompare(b.username));
    } else {
      console.error(`Error: Failed to fetch users. Status: ${response.status}`);
      return null;
    }
  } catch (error) {
    console.error("Error: Network or other error occurred while fetching users.", error);
    return null;
  }
}

export async function getUser(id) {
  try {
    const response = await fetch(
      `https://j7shvfbeg2.execute-api.ap-southeast-1.amazonaws.com/prod/getUser/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error(
        `Error: Failed to fetch user by id. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while fetching user by id.",
      error
    );
    return null;
  }
}

export async function postUser(userParameters = {}) {
  try {
    const response = await fetch(
      "https://ugdmn5pwqb.execute-api.ap-southeast-1.amazonaws.com/prod/postUser",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userParameters),
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      console.error(`Error: Failed to post user data. Status: ${response.status}`);
      return null;
    }
  } catch (error) {
    console.error("Error: Network or other error occurred while posting user data.", error);
    return null;
  }
}

export async function putUser(id, userParameters = {}) {
  const submitData = {
    ...userParameters,
  };

  console.log("putUser called with id:", id);
  console.log("putUser called with userParameters:", userParameters);

  try {
    const response = await fetch(
      `https://aeexj4o5wd.execute-api.ap-southeast-1.amazonaws.com/prod/putUser/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to update user data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while updating user data.",
      error
    );
    return null;
  }
}

export async function getCacheUsers() {
  try {
    const response = await fetch(
      "https://aovqr9dsdl.execute-api.ap-southeast-1.amazonaws.com/prod/getCacheUsers",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      const data = await response.json();

      const sortedUsers = data.sort((a, b) => a.name.localeCompare(b.name));
      return sortedUsers;
    } else {
      console.error(
        `Error: Failed to fetch cache users. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while fetching cache users.",
      error
    );
    return null;
  }
}

export async function putCacheUser(id, cacheUserParameters = {}) {
  const submitData = {
    ...cacheUserParameters,
  };

  try {
    const response = await fetch(
      `https://nh7b6arxyg.execute-api.ap-southeast-1.amazonaws.com/prod/putCacheUser/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      }
    );

    console.log("API Response:", response);

    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to update cache user data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while updating cache user data.",
      error
    );
    return null;
  }
}

export async function deleteUser(id) {
  try {
    const response = await fetch(
      `https://cojsjwuixj.execute-api.ap-southeast-1.amazonaws.com/prod/user/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);
    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to delete user data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while deleting user data.",
      error
    );
    return null;
  }
}


export async function putUserPassword(id, newPassword) {
  const submitData = {
    password: newPassword,
  };

  console.log("putUserPassword called with id:", id);
  console.log("putUserPassword called with newPassword:", newPassword);

  try {
    const response = await fetch(
      `https://kevx8abqfc.execute-api.ap-southeast-1.amazonaws.com/prod/putUserPassword/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to update user password. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while updating user password.",
      error
    );
    return null;
  }
}


export async function putUserPasswordReset(email) {
  try {
    // Define the API endpoint
    const apiUrl =
      "https://2ectbi5lhd.execute-api.ap-southeast-1.amazonaws.com/prod/putUserPasswordReset";

    // Make the API call
    const response = await fetch(apiUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }), // Pass the email in the body as JSON
    });

    // Handle the response
    if (response.ok) {
      const data = await response.json();
      console.log("Password reset email sent successfully:", data.message);
      return data;
    } else {
      console.error(
        `Error: Failed to send password reset email. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while sending password reset email.",
      error
    );
    return null;
  }
}

/**
 * Fetch users whose "roles" list matches the given roles.
 * @param {string|string[]} roles - e.g., "Admin,Technician" or ["Admin","Technician"]
 * @param {Object} [options]
 * @param {"any"|"all"} [options.match="any"] - "any" (default) or "all"
 * @param {number} [options.limit=25]         - page size (matches your Lambda behavior)
 * @param {string} [options.lastEvaluatedKey] - pass back the cursor from previous response
 * @returns {Promise<Object|null>}            - returns the backend JSON (e.g. { items, count, scannedCount, lastEvaluatedKey, ... }) or null on error
 */
export async function getUsersByRoles(roles, { match = "any", limit = 25, lastEvaluatedKey } = {}) {
  // Normalize roles into a comma-separated path segment
  const list = Array.isArray(roles)
    ? roles
    : String(roles || "")
        .split(",")
        .map((r) => r.trim())
        .filter(Boolean);

  if (list.length === 0) {
    console.error("getUsersByRoles: roles must be a non-empty string or array.");
    return null;
  }

  // Build URL: /getUsersByRoles/{roles}?match=&limit=&lastEvaluatedKey=
  const base = "https://yr0ly3o82k.execute-api.ap-southeast-1.amazonaws.com/prod/getUsersByRoles";
  const rolesPath = encodeURIComponent(list.join(",")); // comma becomes %2C, which API Gateway decodes
  const qs = new URLSearchParams();
  if (match) qs.set("match", match);
  if (limit != null) qs.set("limit", String(limit));
  if (lastEvaluatedKey) qs.set("lastEvaluatedKey", lastEvaluatedKey);

  const url = `${base}/${rolesPath}${qs.toString() ? `?${qs.toString()}` : ""}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (response.ok) {
      return await response.json();
    } else {
      console.error(`Error: Failed to fetch users by roles. Status: ${response.status}`);
      return null;
    }
  } catch (error) {
    console.error("Error: Network or other error occurred while fetching users by roles.", error);
    return null;
  }
}
